import { useDispatch } from "react-redux"
import { removeRange, updateRange } from "../../../../redux/features/configuration/parts/effectivitySlice";
import Input from "../../../../components/Inputs/Input";


export const EffRange = ({r,  i, effRangeType, effTempId, disabled}) => {
    const dispatch = useDispatch();
    const deleteRange = () => {
        dispatch(removeRange({effTempId, rangeTempId: r.tempId}))
    }
    return (
        <div className='range'>
            <b>Range {i + 1}</b>
            <div>
                <div className={`${r.error && 'error'}`}>

                <span>From</span>
                <Input disabled={disabled} isNumeric={['line', 'serial'].includes(effRangeType)} onChange={e => dispatch(updateRange({ effTempId, rangeIdx: i, name: "from", value: e.target.value }))} value={r.from} label="" />
                <span>To</span>
                <Input disabled={disabled} isNumeric={['line', 'serial'].includes(effRangeType)} onChange={e => dispatch(updateRange({ effTempId, rangeIdx: i, name: "to", value: e.target.value }))} value={r.to} label="" />
                </div>
                {Boolean(r.error) && <span>{r.error}</span>}
            </div>
           {!disabled && <i onClick={()=>deleteRange()} className='icon-delete-new'></i>
}

        </div>
    )
}